import Spare_module from '@/spare/module';

export default {
  modelName: 'content_text',
  label: '文案管理',
  fields: {
    sequence: {
      type: 'text',
      label: '排序',
    },
    label: {
      type: 'text',
      label: '標題',
    },
    text: {
      type: 'textarea',
      label: '內容',
      maxlength: 10000,
    },
    module: {
      type: 'select',
      label: '模組',
      items: Spare_module.list,
    },
    is_user_editable: {
      type: 'switch',
      label: '前台使用者是否可編輯',
      defaultValue: false,
      activeText: '可以',
      inactiveText: '不可以',
    },
    for: {
      type: 'select',
      label: '適用前後台',
      rules: 'required',
      items: [
        {
          text: '前台',
          value: 'app',
        },
        {
          text: '後台',
          value: 'platform',
        },
      ],
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
  },
};
